export default __webpack_public_path__ + "static/media/IMG-20240822-WA0017.cda9f602.jpg";